import { Collapse } from '@theneatcompany/nui'

export default Collapse
